import React, { useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { useAlert } from '../context/AlertContext';

const CreateBloggerModal = ({ showModal, handleClose, forBlogHead = false }) => {
  const API_HOST = process.env.REACT_APP_API_URL;
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const showAlert = useAlert();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    const authToken = sessionStorage.getItem('authToken');

    // Use the appropriate endpoint based on user type
    const endpoint = forBlogHead 
      ? `${API_HOST}blogs2/createBloggerForBlogHead`
      : `${API_HOST}blogs2/createBlogger`;

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'auth-token' : authToken,
        },
        body: JSON.stringify({
          name,
          email,
          password,
          userType: 'blogger',
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to create blogger');
      }

      showAlert('Blogger created successfully!', 'success');
      setName('');
      setEmail('');
      setPassword('');
      handleClose();
    } catch (error) {
      setMessage(error.message);
      showAlert(error.message, 'danger');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={showModal} onHide={handleClose} centered dialogClassName="modal-modern">
      <Modal.Header closeButton className="bg-dark text-white">
        <Modal.Title>Create New Blogger</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-secondary text-light">
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="bloggerName" className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter full name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="bg-dark text-white border-secondary"
            />
          </Form.Group>

          <Form.Group controlId="bloggerEmail" className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="bg-dark text-white border-secondary"
            />
          </Form.Group>

          <Form.Group controlId="bloggerPassword" className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="bg-dark text-white border-secondary"
            />
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            className="w-100"
            style={{ backgroundColor: '#c4ef17', color: '#000000' }}
            disabled={loading}
          >
            {loading ? (
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            ) : (
              'Create Blogger'
            )}
          </Button>
        </Form>
        {message && <p className="mt-3 text-center text-danger">{message}</p>}
      </Modal.Body>
    </Modal>
  );
};

export default CreateBloggerModal;
